import { api } from "../../lib/api";

const KEY_SRC = "tr_scan_src";
const KEY_REF = "tr_scan_ref";
const KEY_VISITOR = "tr_visitor";

export const visitorId = () => {
  let v = localStorage.getItem(KEY_VISITOR);
  if (!v) {
    v = window.crypto?.randomUUID ? window.crypto.randomUUID() : Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem(KEY_VISITOR, v);
  }
  return v;
};

export const captureScanParams = (params) => {
  if (params.get("src")) sessionStorage.setItem(KEY_SRC, params.get("src").slice(0, 64));
  if (params.get("ref")) sessionStorage.setItem(KEY_REF, params.get("ref").slice(0, 32));
};

export const scanContext = () => ({
  src: sessionStorage.getItem(KEY_SRC) || null,
  ref: sessionStorage.getItem(KEY_REF) || null,
  visitor_id: visitorId(),
});

export const trackScan = (extra = {}) =>
  api.post("/public/scan/track", { ...scanContext(), path: window.location.pathname, ...extra }).catch(() => {});

export const PARTY_DOT = { Democratic: "bg-sky-400", Republican: "bg-rose-400", Independent: "bg-amber-300", Libertarian: "bg-yellow-300", Green: "bg-emerald-400" };
export const money = (v) => (v == null ? "—" : `$${Number(v).toLocaleString(undefined, { maximumFractionDigits: 0 })}`);
export const num = (v) => Number(v || 0).toLocaleString();
